export class CommonConstant {
  static status_code = {
    success: '200',
    refresh: '401',
    refresh_msg: 'Expired',
    status_code_key: 'status_code'
  }
  static spinnerOn = 'on';
  static spinnerOff = 'off';
  static condition_key = {
    active_status: { key: 'activate', label: 'Activate', status: 'active' },
    deactive_status: { key: 'deactivate', label: 'Deactivate', status: 'inactive' }
  }
  static record_status = [
    { label: 'Active', value: 'active' },
    { label: 'Inactive', value: 'inactive' },
  ];

  static nameBgColors: string[] = ["bg-blue-dim", "bg-blue-dim", "bg-azure-dim", "bg-indigo-dim", "bg-info-dim", "bg-purple-dim", "bg-pink-dim", "bg-orange-dim", "bg-teal-dim", "bg-primary-dim", "bg-success-dim", "bg-warning-dim", "bg-danger-dim", "bg-secondary-dim", "bg-dark-dim", "bg-gray-dim", "bg-blue-dim", "bg-azure-dim", "bg-indigo-dim", "bg-info-dim", "bg-purple-dim", "bg-pink-dim", "bg-orange-dim", "bg-teal-dim", "bg-primary-dim", "bg-success-dim", "bg-warning-dim", "bg-danger-dim", "bg-secondary-dim", "bg-dark-dim", "bg-gray-dim"];
  static nameBorderColors: string[] = ["bg-outline-primary", "bg-outline-success", "bg-outline-info", "bg-outline-gray", "bg-outline-warning", "bg-outline-dark", "bg-outline-light", "bg-outline-secondary", "bg-outline-danger"];
  static imageBase64: string = 'data:image/png;base64,';
  static updateSuccessMsg: string = 'updated successfully...!';
  static success: string = 'Success';
  static error: string = 'Error';
  static createSuccessMsg: string = 'Created successfully...!';
  static responseKeys = {
    clients: 'clients',
    country: 'country',
    regions: 'regions',
    languages: 'languages'
  }
}
